import { PageMeta } from '../components/PageMeta';
import { ScrollReveal } from '../components/ScrollReveal';
import { Band, Btn, SectionHead } from '../site/primitives';
import { AstronautArt, FinalCTA, Hero, ValueColumn } from '../site/sections';
import { ART } from '../site/media';

const benefits = [
  { icon: 'shield-check' as const, title: 'Offer protection simply', body: 'Integrate Enshield once and give customers the choice to add Package Protection at checkout.' },
  { icon: 'users' as const, title: 'Reduce support workload', body: 'When a protected delivery is lost, stolen, or damaged, customers file directly with Enshield and we handle the claim.' },
  { icon: 'chart' as const, title: 'Create economic upside', body: 'Protected orders can add incremental profit while helping turn delivery problems into repeat purchases.' },
];

export function MerchantsPage() {
  return <>
    <PageMeta title="Enshield for merchants" description="Offer managed Package Protection at checkout while Enshield handles customer claims and resolutions." />
    <Hero titleId="merchants-title" eyebrow="For merchants" title={<>Package Protection, handled for you.</>} lead="Offer Package Protection at checkout, reduce delivery-related support work, and participate in the economic upside." actions={<Btn to="/book-a-call">Book a Call</Btn>} art={<AstronautArt {...ART.storefront} drift priority />} />
    <Band space="spacious" labelledBy="merchant-benefits-title">
      <ScrollReveal className="u-stack u-stack--xl">
        <SectionHead align="center" eyebrow="A managed service" titleId="merchant-benefits-title" title="Integrate once. Enshield handles the rest." />
        <div className="p-values">{benefits.map((benefit) => <ValueColumn key={benefit.title} icon={benefit.icon} title={benefit.title}>{benefit.body}</ValueColumn>)}</div>
      </ScrollReveal>
    </Band>
    <FinalCTA titleId="merchants-cta-title" title="Ready to make Package Protection work for your business?" primary={{ label: 'Book a Call', to: '/book-a-call' }} />
  </>;
}
